import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import Box from '@material-ui/core/Box';
import {makeStyles} from '@material-ui/core/styles';

import AppContext from '../../utility/AppContext';
import Layouts from './Layouts';
import {ContentView} from '../../index';
import useStyles from '../../../shared/jss/common/common.style';
import {AppState} from '../../../redux/store';
import AppContextPropsType, {
  CremaTheme,
} from '../../../types/AppContextPropsType';

//Comment here to solve AppHeader Disappear after refresh

const useStyle = makeStyles((theme: CremaTheme) => ({
  appAuth: {
    flex: 1,
    display: 'flex',
    position: 'fixed',//relative
    height: '100vh',
    width: '100vw',
    //height: 'calc(100vh - calc(100vh - 100%))',
    //backgroundColor: '#000000',//#f3f4f6 // this is login background color
    [theme.breakpoints.down('sm')]: {
      height: 'calc(var(--vh, 1vh) * 100)',
      //height: '100vh',
      background: `url(./assets/images/background-phone.png) no-repeat center center`,
      backgroundSize: 'cover',
      position: 'fixed',
    },
    backgroundSize: 'cover',

    '& .scrollbar-container': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .main-content-view': {
      padding: 20,
    },
    '& .footer': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
}));

interface CremaLayoutProps {}

const CremaLayout: React.FC<CremaLayoutProps> = () => {
  useStyles();
  const {navStyle} = useContext<AppContextPropsType>(AppContext);
  const {user} = useSelector<AppState, AppState['auth']>(({auth}) => auth);
  const AppLayout = Layouts[navStyle];

  const classes = useStyle();
  return (
    <>
      {user ? (
        <AppLayout />
      ) : (
        <Box className={classes.appAuth}>
          <ContentView />
        </Box>
      )}
    </>
  );
};

export default React.memo(CremaLayout);
